// watch for form validity state
// <form js-form-watcher>
// update: everytime form field change
//      return { state: true/false, invalid:['id', 'id']} 
//      return validityState and 

export default class FormWatcher {
    constructor(private formElement: HTMLFormElement) {

    }

    init = () => {
        this._wireup();

        // re-initiate after svelte mounted
        document.addEventListener("svelte.mounted", () => {
            this._wireup();
        })
        document.addEventListener("svelte.rendered", () => {
            this._wireup();
        })
    }

    private _wireup = () => {
        this._checkFormValidity();
        // get all fields
        for (let i = 0; i < this.formElement.elements.length; i++) {
            const formControl = this.formElement.elements[i] as (HTMLButtonElement | HTMLFieldSetElement | HTMLInputElement | HTMLOutputElement | HTMLSelectElement | HTMLTextAreaElement);
            // only field with validation
            if (formControl.willValidate) {
                if (formControl.tagName === "SELECT") {
                    // remove existing event
                    formControl.removeEventListener("change", this._formControlHandle);
                    // add event
                    formControl.addEventListener("change", this._formControlHandle);

                }
                else if (formControl.tagName === "INPUT") {
                    if (formControl.type === "checkbox" || formControl.type === "radio") {
                        // remove existing event
                        formControl.removeEventListener("change", this._formControlHandle);
                        formControl.removeEventListener("click", this._formControlHandle);
                        // add event
                        formControl.addEventListener("change", this._formControlHandle);
                        formControl.addEventListener("click", this._formControlHandle);
                    } else {
                        // remove existing event
                        formControl.removeEventListener("change", this._formControlHandle);
                        formControl.removeEventListener("input", this._formControlHandle);
                        // add event
                        formControl.addEventListener("change", this._formControlHandle);
                        formControl.addEventListener("input", this._formControlHandle);
                    }
                } else if (formControl.tagName === "TEXTAREA") {
                    // remove existing event
                    formControl.removeEventListener("change", this._formControlHandle);
                    formControl.removeEventListener("input", this._formControlHandle);
                    // add event
                    formControl.addEventListener("change", this._formControlHandle);
                    formControl.addEventListener("input", this._formControlHandle);
                }
            }
        }
    }
    private _formControlHandle = (e: Event) => {
        const formControl = e.target as HTMLElement;
        if (formControl.classList.contains("input-validation-error")) {
            formControl.classList.remove("input-validation-error");
        }
        this._checkFormValidity();
    }
    private _checkFormValidity = (e: Event = null) => {
        // get invalid messages
        const messages = [];
        for (let i = 0; i < this.formElement.elements.length; i++) {
            const formControl = this.formElement.elements[i] as (HTMLButtonElement | HTMLFieldSetElement | HTMLInputElement | HTMLOutputElement | HTMLSelectElement | HTMLTextAreaElement);
            if (!formControl.validity.valid || formControl.classList.contains("input-validation-error") || formControl.classList.contains("is-invalid")) {
                let errorMessage = `Field required.`;
                // try get custom message
                if (formControl.nextElementSibling && formControl.nextElementSibling.classList.contains("invalid-feedback")) {
                    errorMessage = formControl.nextElementSibling.textContent;
                } else {
                    const name = this._getElementName(formControl);
                    if (!!name) {
                        errorMessage = `Please complete ${name}`;
                    }
                }

                messages.push(errorMessage);
            }
        }

        const result = this.formElement.checkValidity() && messages.length === 0;

        this.formElement.dispatchEvent(new CustomEvent('update', {
            detail: {
                state: result,
                invalid: messages
            }
        }));
    }
    private _getElementName = (element: HTMLElement) => {
        let name = "";
        if (!!element.getAttribute("name")) {
            name = element.getAttribute("name");
        } else if (!!element.getAttribute("id")) {
            name = element.getAttribute("id");
        }

        if (name.indexOf(".") >= 0) {
            name = name.substring(name.lastIndexOf(".") + 1);
        }
        return name;
    }
}